// src/redux/slices/iframeSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requesterIframeUrl: null,
};

const requesterIframeSlice = createSlice({
  name: "requesterIframe",
  initialState,
  reducers: {
    setRequesterIframeUrl: (state, action) => {
      state.requesterIframeUrl = action.payload;
    },
    clearRequesterIframeUrl: (state) => {
      state.requesterIframeUrl = null;
    },
  },
});

export const { setRequesterIframeUrl, clearRequesterIframeUrl } = requesterIframeSlice.actions;
export default requesterIframeSlice.reducer;
